import { getRecentFilesList, FileListLoadingStatus } from 'owa-group-files-hub-store';
import { getRecentFilesFromCache, refreshRecentFiles } from 'owa-group-files-hub-actions';
import updateRecentFilesLoadingStatus from 'owa-group-files-hub-store/lib/actions/updateRecentFilesLoadingStatus';

export default function getRecentFiles(groupSmtpAddress: string) {
    const recentFilesList = getRecentFilesList(groupSmtpAddress);

    // Update the fileListLoadingStatus in RecentFilesStore for that group
    updateRecentFilesLoadingStatus(groupSmtpAddress, FileListLoadingStatus.Loading);

    if (recentFilesList.fileItems) {
        // only refresh the list if there are already some files in the store for that group.
        refreshRecentFiles(groupSmtpAddress);
    } else {
        getRecentFilesFromCache(groupSmtpAddress);
        refreshRecentFiles(groupSmtpAddress);
    }
}
